import { motion } from 'framer-motion';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { GridCell } from 'components/shared/grid';
import { getTextWithoutParagraph } from 'utils';

import IllustrtationCardLogoSvgUrl from './images/illustration-card-logo.url.svg';
import IllustrtationCardOneSvgUrl from './images/illustration-card-one.url.svg';
import IllustrtationCardThreeSvgUrl from './images/illustration-card-three.url.svg';
import IllustrtationCardTwoSvgUrl from './images/illustration-card-two.url.svg';
import TriangleSvgUrl from './images/solutions-retention.url.svg';
import {
  Wrapper,
  Inner,
  Grid,
  ContentLeft,
  ContentRight,
  StyledTitle,
  Description,
  BackgroundImageWrapper,
  TriangleImage,
} from './service-providers-discounts.styles';

export const Discounts = ({ title, description }) => {
  const [animationContainer, animationContainerView] = useInView({
    threshold: 1,
  });

  const motionEase = [0.25, 0.1, 0.25, 1];

  const variantsContentFade = {
    hidden: {
      opacity: 0,
    },
    visible: (custom) => ({
      opacity: 1,
      transition: { delay: custom, duration: 0.5, ease: motionEase },
    }),
  };

  const variantsPosition = {
    hidden: {
      opacity: 0,
    },
    visible: (custom) => ({
      opacity: 1,
      y: custom,
    }),
  };
  return (
    <Wrapper>
      <Inner>
        <Grid
          columns={2}
          gap={0}
          media={{
            sm: { columns: 1 },
          }}
        >
          <GridCell>
            <ContentLeft>
              <StyledTitle
                as="h2"
                size="xl"
                dangerouslySetInnerHTML={{
                  __html: getTextWithoutParagraph(title),
                }}
              />
              <Description
                dangerouslySetInnerHTML={{
                  __html: getTextWithoutParagraph(description),
                }}
              />
            </ContentLeft>
          </GridCell>
          <GridCell>
            <ContentRight ref={animationContainer}>
              <motion.div
                className="illustration-wrapper"
                initial="hidden"
                animate={animationContainerView && 'visible'}
              >
                <motion.img
                  src={IllustrtationCardThreeSvgUrl}
                  className="illustration-card-three"
                  variants={variantsPosition}
                  custom={-50}
                  transition={{ delay: 0.8, duration: 0.5, ease: motionEase }}
                />
                <motion.img
                  src={IllustrtationCardTwoSvgUrl}
                  className="illustration-card-two"
                  variants={variantsPosition}
                  custom={-50}
                  transition={{ delay: 0.5, duration: 0.5, ease: motionEase }}
                />
                <motion.img
                  src={IllustrtationCardOneSvgUrl}
                  className="illustration-card-one"
                  variants={variantsPosition}
                  custom={-70}
                  transition={{ delay: 0, duration: 0.7, ease: motionEase }}
                />
                <motion.img
                  src={IllustrtationCardLogoSvgUrl}
                  className="illustration-card-logo"
                  variants={variantsContentFade}
                  custom={1.5}
                />
              </motion.div>
            </ContentRight>
          </GridCell>
        </Grid>
      </Inner>
      <BackgroundImageWrapper>
        <TriangleImage src={TriangleSvgUrl} />
      </BackgroundImageWrapper>
    </Wrapper>
  );
};
